

import { planTypes } from '@/common/constants';
import { defaultMapper } from '@/common/service/default-mapper';

const videosdkCategory = {
  sdkpayongo: { typeNameKey: 'billing.planform.title.video_sdk', planNameKey: '' },
};

export default (planMapJSON = {}) => {
  return Object.keys(videosdkCategory).reduce((pre, key) => {
    return [
      ...pre,
      ...defaultMapper(planMapJSON[key], planTypes.VIDEO_SDK).map(item => {
        return {
          ...item,
          category: item.category.toLocaleLowerCase(),
          ...videosdkCategory[key],
          excessPrice: planMapJSON[key]?.excessPrice,
          excessPriceCents:  planMapJSON[key]?.excessPriceCents,
          planNameKey: 'billing.planform.title.video_sdk'
        }
  }),
    ];
  }, []);
}



